import { Component, OnInit } from '@angular/core';
import { LoginModel } from '../../login/login-model';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { ActivatedRoute, Router } from '@angular/router'

declare var $;

@Component({
  selector: 'app-pwd-change',
  templateUrl: './pwd-change.component.html',
  styleUrls: ['./pwd-change.component.css']
})
/** pwd-change component*/
export class PwdChangeComponent implements OnInit {
  LoginId: string = '';
  modelItem: LoginModel = new LoginModel();
  Password: string = '';
  constructor(private route: ActivatedRoute, private routerLink: Router) {
    this.loadGeneralmethod();
  }
  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.LoginId = params.get("keyid");
    }); // output:
  }

  loadGeneralmethod() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <LoginModel>data["LoginPage"];
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  ChangePassword() {
    let pwdReg = new RegExp(this.modelItem.PasswordFormatReset);
    if (this.Password == '') {
      ngswal("Warning !", 'Please enter new password !', "warning");
    }
    else if (!pwdReg.test(this.Password)) {
      ngswal("Warning !", this.modelItem.PasswordMsg, "warning");
    }
    else {
      $("#LoadingImage").show();
      var userItem = {
        LoginID: this.LoginId,
        Password: this.Password,
        UpdateMode: "ChangePassword",
        DefaultPage: $('base')[0].href
      };
      ApiMethod.postMethod(this.modelItem.ForgotPasswordAPI, userItem).subscribe(
        result => {
          $("#LoadingImage").hide();
          if (result.Message != null) {
            ngswal("Reset Password", result.Message, "warning");
          }
          else {
            this.routerLink.navigate(['login']);
            ngswal("Reset Password", result, "info");
          }

        }, error => {
          $("#LoadingImage").hide();
          try {
            ngswal("Warning !", error.error.Message, "warning");
          } catch (e) {
            ngswal("Warning !", error.Message, "warning");
          }
        });
    }

  }

  updateType() {
    var passwordType = $('#password').attr("type");

    if (passwordType == "password") {
      $("#password").attr("type", "text");
      $("#password-addon").html("<i class='far fa-eye'></i>");
    }
    else if (passwordType == "text") {
      $("#password").attr("type", "password");
      $("#password-addon").html("<i class='far fa-eye-slash'></i>");
    }
  }
}
